import React from 'react'

import { string, number, arrayOf, shape, array } from 'prop-types'

import i18n from 'Pods/Shared/I18n'

import ItemsSearchUrlBuilder from 'Utils/ItemsSearchUrlBuilder'
import { EMPTY_ARRAY } from 'Utils/stableDefaults'

function UserShowMoreButton({ userName, modelCount, locale, categories = EMPTY_ARRAY }) {
  const getUrl = () => {
    // If there's only one category, use that category's filter
    const categoryFilter = categories?.[0]?.categoryFilter

    if (categories?.length === 1 && categoryFilter) {
      const urlBuilder = new ItemsSearchUrlBuilder()

      if (categoryFilter === 'print_ready') {
        urlBuilder.set({
          pathname: '/3d-print-models',
          search: '?',
        })
      } else {
        urlBuilder.set({
          pathname: '/3d-models',
          search: `?${categoryFilter}=1`,
        })
      }

      return urlBuilder.applyFilter('author', userName)
    }

    // Multiple categories: use base URL
    return `/3d-models?author=${userName}`
  }

  return (
    <div className="user-models__load-more-row u-text-center">
      <button
        type="button"
        className="btn btn-primary text-semibold"
        onClick={() => {
          window.location.href = getUrl()
        }}
      >
        {i18n.t('profilePage.seeAllModels', { ns: 'rails', lng: locale, modelCount })}
      </button>
    </div>
  )
}

UserShowMoreButton.propTypes = {
  userName: string.isRequired,
  modelCount: number.isRequired,
  locale: string.isRequired,
  categories: arrayOf(
    shape({
      category: string,
      title: string,
      categoryCount: number,
      categoryFilter: string,
      items: array,
    })
  ),
}

export default UserShowMoreButton
